import { useNavigate, useParams } from "react-router";
import { useEffect, useState } from "react";
import restaurantsData from "../data/restaurants.json";
import tablesData from "../data/tables.json";
import { useApp } from "../Context";

export default function TablePromptPage() {
    const navigate = useNavigate();
    const { restaurant } = useParams();
    const { table: contextTable, setTable, getCfg } = useApp();

    const [validRestaurant, setValidRestaurant] = useState(false);
    const [tableList, setTableList] = useState([]);
    const [tableNumber, setTableNumber] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const foundRestaurant = restaurantsData.find(r => r.slug === restaurant);
        if (!foundRestaurant) {
            setLoading(false);
            return;
        }

        setValidRestaurant(true);
        setTableList(tablesData[restaurant] || []);

        const hashTable = window.location.hash.replace("#", "").trim() || contextTable;

        if (hashTable) {
            tableExists(hashTable, restaurant).then(isValid => {
                if (isValid) {
                    setTableNumber(hashTable);
                    handleTableSubmit(hashTable);
                } else {
                    setLoading(false);
                }
            });
        } else {
            setLoading(false);
        }
    }, [restaurant]);

    const tableExists = async (table, restaurant) => {
        const entry = tablesData[restaurant] ?? (await getCfg()).zones;
        console.log(entry)

        if (!entry) return false;

        if (Array.isArray(entry) && entry[0]?.fbord !== undefined) {
            const numTable = parseInt(table, 10);
            return entry.some(zone => {
                const from = parseInt(zone.fbord, 10);
                const to = parseInt(zone.tbord, 10);
                const abord = zone.abord || [];
                return (numTable >= from && numTable <= to) || abord.includes(String(table));
            });
        }

        if (Array.isArray(entry)) {
            return entry.includes(String(table));
        }

        return false;
    };

    const handleTableSubmit = async (manualInput) => {
        const entered = manualInput || tableNumber.trim();
        setError("");

        if (!entered) {
            setError("Ange ett bordsnummer.");
            return;
        }

        setLoading(true);

        const isValid = await tableExists(entered, restaurant);
        if (!isValid) {
            setError("Bordet finns inte.");
            setLoading(false);
            return;
        }

        try {
            await setTable(entered); // store in context + localStorage
            navigate(`/${restaurant}/order`);
            navigate(0)
        } catch (err) {
            setError("Ett fel uppstod. Försök igen.");
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return (
            <div className="text-center mt-5">
                <div className="spinner-border text-warning" />
                <h3>Laddar...</h3>
            </div>
        );
    }
    {/*
        if (!validRestaurant) {
            return (
                <div className="container text-center mt-5">
                    <h2 className="fw-bold text-danger">Restaurang hittades inte</h2>
                    <p className="text-muted">Restaurangen du sökte efter finns inte i vårt system.</p>
                    <button className="btn btn-warning fw-semibold text-dark mt-4 px-4 py-2" onClick={() => navigate("/")}>
                        Till startsidan
                    </button>
                </div>
            );
        }
        */
    }

    return (
        <div className="container text-center mt-5">
            <h2 className="fw-bold">Skanna QR-koden</h2>
            <p className="text-muted">Skanna QR-koden på ditt bord för att komma igång.</p>

            <div className="my-4 fw-semibold text-uppercase text-muted">eller</div>
            <p className="text-muted mb-3">Ange ditt bordsnummer manuellt nedan:</p>

            <div className="d-flex justify-content-center align-items-center gap-2">
                <input
                    type="text"
                    className={`form-control text-center fw-semibold ${error ? "border-danger" : "border-secondary"} shadow-sm`}
                    style={{ maxWidth: "200px", padding: "10px", fontSize: "1rem" }}
                    placeholder="Bordsnummer"
                    value={tableNumber}
                    onChange={(e) => {
                        setTableNumber(e.target.value);
                        setError("");
                    }}
                    onKeyDown={(e) => e.key === "Enter" && handleTableSubmit()}
                    disabled={loading}
                />
                <button
                    className="btn btn-warning text-dark fw-semibold px-4 py-2 shadow-sm"
                    onClick={() => handleTableSubmit()}
                    disabled={loading}
                >
                    {loading ? (
                        <div className="spinner-border spinner-border-sm text-dark" role="status">
                            <span className="visually-hidden">Laddar...</span>
                        </div>
                    ) : (
                        "Fortsätt"
                    )}
                </button>
            </div>

            {error && <p className="text-danger mt-3 fw-semibold">{error}</p>}
        </div>
    );
}
